import React from 'react'

import { Heading, Pagination } from 'core'
import { Spacer } from 'layout'

import ProgramCard from './ProgramCard'

import css from './style.scss'

const ProgramsAndCoursesSection = ({ events, pages }) => {
  if (!pages) return null

  return (
    <section aria-labelledby='programs-and-courses-heading' className={css.programsSection}>
      <Spacer size='md' />
      <div className={css.sectionHeader}>
        <Heading id='programs-and-courses-heading' size='h3' weight='semibold' noMargin>
          Programs &amp; Courses
        </Heading>
      </div>
      {events.map(event => (
        <ProgramCard key={`${event.type}-${event.id}`} event={event} />
      ))}
      {pages > 1 && <Pagination pages={pages} pageParamKey='programsPage' />}
    </section>
  )
}

ProgramsAndCoursesSection.propTypes = {
  events: React.PropTypes.array.isRequired,
  pages: React.PropTypes.number.isRequired
}

export default ProgramsAndCoursesSection
